(function () {
  const hasBuildsystemProducts = !!document.querySelector('.buildsystem-product');
  const hasBuildsystemCart = !!document.querySelector('[data-sticky-cart]');
  if (!hasBuildsystemProducts && !hasBuildsystemCart) return;

  /* helpers */
  const moneyFormat = (cents, locale = 'en-US', currency = Shopify.currency.active || 'USD') =>
    (cents / 100).toLocaleString(locale, { style: 'currency', currency });

  const getMeasurementFlow = () => {
    const quizContext = window.BSNQuizMeasurementContext;
    const quizVariant = quizContext && String(quizContext.quiz_variant || '').trim();
    return {
      sourceComponent: window.location.pathname.replace(/\/$/, '') === '/pages/veteran-appointment-plan'
        ? 'veteran_planner' : (quizVariant ? 'recommendation_quiz' : 'build_your_bundle'),
      quizVariant: quizVariant || null
    };
  };

  const getSubtotalCents = () => {
    const cards = Array.from(document.querySelectorAll('.buildsystem-product__card'));
    return cards.reduce((sum, card) => {
      const qtyInput = card.querySelector('input[id^="qty-"]');
      const qty = parseInt(qtyInput && qtyInput.value ? qtyInput.value : '0', 10) || 0;
      if (qty <= 0) return sum;

      const priceNode = card.querySelector('[data-price]');
      const priceText = priceNode ? priceNode.innerText : '';
      const price = parseInt(String(priceText || '').replace(/[^0-9]/g, ''), 10) || 0;
      return sum + (price * qty);
    }, 0);
  };

  /* --- Quantity handling --- */
  /* --- Qty buttons logic --- */
  document.querySelectorAll('.card__qty').forEach(qtyContainer => {
    const minusBtn = qtyContainer.querySelector('.qty-btn.minus');
    const plusBtn = qtyContainer.querySelector('.qty-btn.plus');
    const qtyInput = qtyContainer.querySelector('input.input--quantity');
    if (!minusBtn || !plusBtn || !qtyInput) return;

    function updateButtonState(qty) {
      if (qty <= 0) {
        minusBtn.classList.add('disabled');
        qtyInput.value = 0;
      } else {
        minusBtn.classList.remove('disabled');
      }
    }

    qtyInput.addEventListener('change', () => {
      if (!window.BSNMeasurement) return;
      const sourceComponent = window.location.pathname.replace(/\/$/, '') === '/pages/veteran-appointment-plan'
        ? 'veteran_planner' : 'build_your_bundle';
      if (sourceComponent === 'veteran_planner' && !window.BSNMeasurement.analyticsAllowed()) return;
      const card = qtyInput.closest('.buildsystem-product__card');
      const quantity = Math.max(0, parseInt(qtyInput.value, 10) || 0);
      const context = {
        interaction_location: 'buildsystem_products',
        display_mode: 'inline',
        item_id: card ? String(card.dataset.variantId || '') : '',
        item_name: card ? String(card.dataset.productHandle || '') : '',
        quantity
      };
      // Planner selections are not shopping intent; omit product/variant details.
      if (sourceComponent === 'veteran_planner') {
        delete context.item_id;
        delete context.item_name;
      }
      if (quantity > 0) {
        window.BSNMeasurement.once(sourceComponent + ':start', () => {
          window.BSNMeasurement.toolEvent('tool_start', sourceComponent, context);
        });
        window.BSNMeasurement.componentView(sourceComponent, {
          interaction_location: 'floating_cart',
          display_mode: 'sticky'
        }, 'view:' + sourceComponent + ':floating-cart');
      }
      window.BSNMeasurement.toolEvent('tool_item_change', sourceComponent, context);
    });

    minusBtn.addEventListener('click', () => {
      let currentQty = parseInt(qtyInput.value, 10) || 0;
      if (currentQty > 0) {
        currentQty -= 1;
        qtyInput.value = currentQty;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        updateButtonState(currentQty);
      }
    });

    plusBtn.addEventListener('click', () => {
      let currentQty = parseInt(qtyInput.value, 10) || 0;
      currentQty += 1;
      qtyInput.value = currentQty;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      updateButtonState(currentQty);
    });

    // Initialize button state
    updateButtonState(parseInt(qtyInput.value, 10) || 0);
  });

  /* --- See details modal --- */
  document.querySelectorAll('[data-see-details]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const dialog = document.getElementById(btn.getAttribute('aria-controls'));
      dialog.showModal();
      btn.setAttribute('aria-expanded', 'true');
    });
  });
  document.querySelectorAll('[data-close-details]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const dialog = btn.closest('dialog');
      dialog.close();
      const opener = document.querySelector(`[aria-controls="${dialog.id}"]`);
      opener && opener.setAttribute('aria-expanded', 'false');
    });
  });

  /* --- Cart bar actions --- */
  const totalEl = document.querySelector('[data-cart-total]');
  const addBtn  = document.querySelector('[data-add-all]');
  if (!totalEl || !addBtn) return;

  const updateTotals = () => {
    const subtotalCents = getSubtotalCents();
    totalEl.textContent = moneyFormat(subtotalCents);
    addBtn.disabled = subtotalCents === 0;
  };

  document.addEventListener('input', (e) => {
    if (e.target && e.target.matches('input[id^="qty-"]')) updateTotals();
  });

  document.addEventListener('click', (e) => {
    if (e.target && e.target.closest('.qty-btn')) setTimeout(updateTotals, 0);
  });

  addBtn.addEventListener('click', async (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

    addBtn.disabled = true;
    addBtn.classList.add('loading');
    const measurementFlow = getMeasurementFlow();
    window.BSNCartDrawerContext = {
      mode: 'buildsystem',
      measurementSourceComponent: measurementFlow.sourceComponent,
      measurementQuizVariant: measurementFlow.quizVariant
    };

    if (window.BSNMeasurement) {
      window.BSNMeasurement.toolEvent('tool_review', measurementFlow.sourceComponent, {
        interaction_location: 'floating_cart',
        display_mode: 'sticky',
        destination_type: 'system_drawer',
        quiz_variant: measurementFlow.quizVariant
      });
    }

    try {
      // Build-system flow is preview-first: opening drawer should never write to cart.
      if (window.BSNCartDrawer && typeof window.BSNCartDrawer.open === 'function') {
        window.BSNCartDrawer.open();
        if (typeof window.BSNCartDrawer.refresh === 'function') {
          await window.BSNCartDrawer.refresh();
        }
      } else if (window['Theme'] && Theme.Cart && Theme.Cart.openCartDrawer) {
        Theme.Cart.openCartDrawer();
      }
    } catch (err) {
      console.error('[BuildSystem] View system failed', err);
    } finally {
      addBtn.classList.remove('loading');
      updateTotals();
    }
  });

  updateTotals();
})();
